import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import UserIcon from "components/common/Svg/User";
import useLogout from "utils/hooks/useLogout";
import { useExternalSupport } from "utils";
import { isSupport } from "routes/pageConfig";
import { hasPagePermission } from "routes/utils";
import { ThemeContext } from "components/common";
import { darkThemeName } from "theme";
import Boop from "../common/Boop";
import { HEADER_DROPDOWN_ITEMS } from "./consts";

const buttonStyle = { lineHeight: "30px", height: "30px" };

const HeaderDropdown = ({ iconColor = "black" }) => {
  const logout = useLogout();
  const history = useHistory();
  const { openExternalSupport } = useExternalSupport();
  const items = HEADER_DROPDOWN_ITEMS;
  const { theme } = useContext(ThemeContext);

  return (
    <li className={ `dropdown ${theme === darkThemeName ? "text-white" : "text-black"}` }>
      <div className="-mb-3 cursor-pointer pb-2 trigger-drop">
        <Boop timing={200} y={3}>
          <div className="flex items-center" style={{ height: "36px" }}>
            <div className="mx-auto">
              <div style={{ width:"31px" }}>
                <UserIcon
                  className=""
                  color={iconColor}
                  alt="user"
                  style={{ width: "31px" }}
                />
              </div>
            </div>
          </div>
        </Boop>
      </div>
      <ul className="drop" style={{ minWidth: "max-content", background: `${theme === darkThemeName ? "black" : "white"}` }}>
        {items.map((item) => {
          const { key, title, path } = item;
          if (!hasPagePermission(item)) {
            return null;
          }
          return (
            <li key={key}>
              <button
                type="button"
                style={buttonStyle}
                onClick={() => {
                  if (isSupport(item)) {
                    openExternalSupport();
                  } else {
                    history.push(path);
                  }
                }}
              >
                {title}
              </button>
            </li>
          );
        })}
        <li>
          <button
            type="button"
            style={buttonStyle}
            onClick={async () => {
              await logout();
            }}
          >
            Log Out
          </button>
        </li>
      </ul>
    </li>
  );
};

export default HeaderDropdown;
